module.exports = __webpack_public_path__ + "img/AlarmaManualEnActivacion.4fbeb8b1.svg";